import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

// Partners owed £50+ ask for their payout by bank transfer or PayPal; the admin pays and records it.
export default function PayoutRequest({ d, onDone }) {
  const [method, setMethod] = useState("bank");
  const [f, setF] = useState({ account_name: "", sort_code: "", account_number: "", paypal_email: "" });
  const [busy, setBusy] = useState(false);
  if (d.pending_request) {
    return (
      <div className="rounded-3xl border border-primary/30 bg-primary/[0.05] p-6 mb-8 text-sm" data-testid="payout-pending">
        Payout of <span className="text-foreground">£{d.pending_request.amount_gbp.toFixed(2)}</span> requested by {d.pending_request.method === "bank" ? "bank transfer" : "PayPal"}. We'll send it shortly and it'll show below once paid.
      </div>
    );
  }
  if (d.owed_gbp < d.payout_min) {
    return <p className="text-xs text-muted-foreground mb-8" data-testid="payout-min-note">You can request a payout once you're owed £{d.payout_min}.</p>;
  }
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const send = async () => {
    setBusy(true);
    try { await api.post("/partner/payout-request", { method, ...f }); toast.success("Payout requested."); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Couldn't send the request."); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-3xl border border-primary/30 bg-primary/[0.05] p-6 mb-8" data-testid="payout-request">
      <h3 className="font-serif text-2xl mb-1">Request your £{d.owed_gbp.toFixed(2)}</h3>
      <p className="text-xs text-muted-foreground mb-4">Choose how you'd like to be paid.</p>
      <div className="flex gap-2 mb-4">
        {[["bank", "Bank transfer"], ["paypal", "PayPal"]].map(([k, l]) => (
          <button key={k} onClick={() => setMethod(k)} data-testid={`payout-method-${k}`}
            className={`px-4 py-2 rounded-full text-sm border transition-colors duration-200 ${method === k ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-primary/50"}`}>{l}</button>
        ))}
      </div>
      {method === "bank" ? (
        <div className="grid sm:grid-cols-3 gap-3 mb-4">
          <Input placeholder="Account name" value={f.account_name} onChange={set("account_name")} data-testid="payout-account-name" />
          <Input placeholder="Sort code" inputMode="numeric" value={f.sort_code} onChange={set("sort_code")} data-testid="payout-sort-code" />
          <Input placeholder="Account number" inputMode="numeric" value={f.account_number} onChange={set("account_number")} data-testid="payout-account-number" />
        </div>
      ) : (
        <Input className="mb-4" type="email" placeholder="PayPal email" value={f.paypal_email} onChange={set("paypal_email")} data-testid="payout-paypal-email" />
      )}
      <Button onClick={send} disabled={busy} className="rounded-full" data-testid="payout-submit-btn">{busy ? "Sending…" : "Request payout"}</Button>
    </div>
  );
}
